module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAABGklEQVQoU42SMUvDYBCG3/ejnbI4VHHoXxD9JYIiOokU0i9rdSoomNRNh3btRUIGccnoIgURd8HFQf+CIImTUMh30iEgUkNuvXtejruH/X5/i+SaiMzQoHzfPzDG3NFaew7gTFVnZVmeJEnyXsdba19J7ldgG8AngKGq3pAcicjXsoC/IEQk6vV6q61W64LktnMu7Ha712EYut8BS8FqIAiCTefchOSKqg7iOH6qerVgNeT7/h7JS5LPeZ4fZVn23RTcNcZcAXjxPO9wPB7Xg9baDVWdAOiQHIjIY+2q1toOgBGAHVWNiqKIsywr/z2Oc65tjPkAcArgdj6fR2maFk3esQAeAByLyFsjARbKGWPWp9PpfQPjUCn3A5/4nDsQWaUyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/audio/rightPlay.png
// module id = XJf6
// module chunks = 1